import { createContext } from 'react';

export interface DistributionGridSelectionContextType {
  selectedAuditIds: number[];
  setSelectedAuditIds: React.Dispatch<number[]>;
}

export const DistributionGridSelectionContext = createContext<
  DistributionGridSelectionContextType | undefined
>(undefined);
